import { ChangeDetectionStrategy, Component, type OnInit, input, type InputSignal } from '@angular/core';
import { ReactiveFormsModule, type FormControl, type FormGroup } from '@angular/forms';
import { DistrictMode } from '@pecan/shared/constants/address.constants';
import { CityInputComponent } from '../city-input/city-input.component';
import { StateInputComponent } from '../state-input/state-input.component';
import { ZipInputComponent } from '../zip-input/zip-input.component';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ReactiveFormsModule, CityInputComponent, StateInputComponent, ZipInputComponent],
    selector: 'app-city-state-zip',
    styleUrls: ['./city-state-zip.component.scss'],
    templateUrl: './city-state-zip.component.html',
})
export class CityStateZipComponent implements OnInit {
    public readonly form: InputSignal<FormGroup> = input.required<FormGroup>();

    public readonly cityRequired: InputSignal<boolean> = input<boolean>(true);

    public readonly stateRequired: InputSignal<boolean> = input<boolean>(true);

    public readonly zipRequired: InputSignal<boolean> = input<boolean>(true);

    public readonly districtMode: InputSignal<DistrictMode> = input<DistrictMode>(DistrictMode.State);

    public get cityControl(): FormControl<string> {
        return this.form()?.controls.city as FormControl<string>;
    }

    public get stateControl(): FormControl<string> {
        return this.form()?.controls.state as FormControl<string>;
    }

    public get zipControl(): FormControl<string> {
        return this.form()?.controls.zip as FormControl<string>;
    }

    public ngOnInit(): void {
        if (!this.cityControl || !this.stateControl || !this.zipControl) {
            throw new Error('CityStateZipComponent: the provided FormGroup is missing the city, state, or zip control');
        }
    }
}
